var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$modal.modalBody !== null),expression:"$modal.modalBody !== null"}],staticClass:"m-the-modal-content-wrapper"},[_vm._t("modal-body")],2)}
var staticRenderFns = []

export { render, staticRenderFns }